export const WARNING = 'WARNING';
export const INFO = 'INFO';
export const CRITICAL = 'CRITICAL';

export const MISSING = 'missing';
export const FOUND = 'found';

export const GREATER_THAN = 'greaterThanOrEqualTo';
export const LESS_THAN = 'lessThanOrEqualTo';
